import React from 'react';
import styled from 'styled-components';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';
import type { ProductReviewRatingStatisticModel, ProductReviewStatisticsModel } from 'autogen/swagger/all';
import { SvgSprite } from 'modules/svgSprite';
import { colors } from 'variables';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const SeeRatingSpread = styled.div``;

const Line = styled.div`
    display: flex;
    align-items: center;
`;

const LineRating = styled.span`
    font-weight: bold;
    flex: 0 0 10px;
`;

const LineIcon = styled(SvgSprite)`
    flex: 0 0 auto;
    width: 32px;
    height: 15px;
`;

const LineGraphic = styled.span<{ percentFilled: number }>`
    flex: 1 1 0;
    height: 5px;
    background: ${colors.backgroundSenary};
    border-radius: 5px;
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        position: absolute;
        background: ${ColorBrandBlue1};
        left: 0;
        top: 0;
        height: 5px;
        width: ${({ percentFilled }): number => percentFilled}%;
        border-radius: 5px;
    }
`;

const LineReviewCount = styled.span`
    flex: 0 0 auto;
    min-width: 32px; // 4 tal
    text-align: right;
    margin-left: 10px;
    font-weight: bold;
`;

interface IRatingLineProps {
    model: ProductReviewRatingStatisticModel;
    totalReviews: number;
}

const RatingLine = (props: IRatingLineProps): JSX.Element => {
    const { model, totalReviews } = props;
    const { rating, numberOfReviews } = model;

    const percent = (numberOfReviews / totalReviews) * 100;

    return (
        <Line>
            <LineRating>{rating}</LineRating>
            <LineIcon sprite="Star" fill={ColorBrandBlue1} />
            <LineGraphic percentFilled={percent} />
            <LineReviewCount>{numberOfReviews}</LineReviewCount>
        </Line>
    );
};

interface IRatingSpreadProps {
    model: ProductReviewStatisticsModel;
}

export const RatingSpread = (props: IRatingSpreadProps): JSX.Element => {
    const { model, ...rest } = props;
    const { ratingStatistics, reviewCount } = model;

    return (
        <Wrapper {...rest}>
            {ratingStatistics.map((x) => (
                <RatingLine key={x.rating} model={x} totalReviews={reviewCount} />
            ))}
        </Wrapper>
    );
};

export default RatingSpread;
